<template>
  <span class="good-btn" :class="size" @click="goodFunc">
    <span class="btn-msg" :class="{'text-red': hadGood}">有用</span>
    <span v-if="showCount" class="count" >{{localGoodCount}}</span>
  </span>
</template>
<script>
import { Cms, Comment } from "@/api";
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    sourceId: {
      required: true
    },
    commentGoodId: {
      type: [Number, String],
      default: 0
    },
    goodCount: {
      type: Number,
      default: 0
    },
    iconSize: {
      type: Number,
      default: 16
    },
    size: {
      type: String,
      // normal 14px;
      // big 16px;
      default: "normal"
    },
    showCount: {
      type: Boolean,
      default: true
    },
    type: {
      type: String,
      // article , comment
      default: "article"
    }
  },
  watch: {
    value: function (val) {
      this.changeGoodStatus(val)
    },
    goodCount: function (val) {
      this.localGoodCount = val
    }
  },
  data() {
    return {
      localGoodCount: this.goodCount,
      hadGood: this.value,
      isFirst: true,
      localCommentGoodId: this.commentGoodId,
      urlMap: {
        article: {
          url: Cms.ToggleGood,
          form: {
            ArticleId: this.sourceId,
            UserId: this.$mdUtils.getUserInfo("Id")
          }
        },
        comment: {
          url: Comment.SaveCommentGood,
          form: {
            CommentId: this.sourceId,
            Avatar: this.$mdUtils.getUserInfo('Avatar'),
            UserName: this.$mdUtils.getUserInfo('NickName')
          }
        }
      }
    };
  },
  
  mounted() {
    this.$nextTick(() => {
      this.isFirst = false
    })
  },
  methods: {
    goodFunc() {
     
      let url = this.urlMap[this.type].url;
      let reqMsg = this.urlMap[this.type].form;

      // if (this.type === 'comment' && this.hadGood) {
      //   this.$api(Comment.DeleteCommentGoodById, {Id: this.commentGoodId}).then(this.handleSuccess);
      //   return 
      // } 
      this.$api(url, reqMsg).then(this.handleSuccess);
    },
    handleSuccess() {
      this.hadGood = !this.hadGood
      this.handleCount()
      this.$emit('onSuccess', this.hadGood)
    },
    changeGoodStatus(val) {
      if(this.hadGood != val) {
        this.hadGood = val
        if (!this.isFirst) {
          this.handleCount()
        } else {
          this.isFirst = false
        }
      }
      
    },
    handleCount() {
      if (this.hadGood) {
        this.localGoodCount++;
      } else {
        this.localGoodCount--;
      }
    }
  }
};
</script>
<style lang='scss' scoped>
.good-btn {
  font-size: 0 !important;
  .good-btn-icon {
    font-size: $font-size-big;
  }
  &.normal {
    .btn-msg {
      font-size: $font-size-normal;
    }
    .count {
      margin-left: 5px;
      font-size: $font-size-normal;
    }
  }
  &.middle {
    .btn-msg {
      font-size: 20px;
    }
    .count {
      margin-left: 5px;
      font-size: 20px;
    }
  }
  &.big {
    .btn-msg {
      font-size: $font-size-normal;
    }
    .count {
      margin-left: 12px;
      font-size: $font-size-big;
    }
  }
}
</style>